export default "__VITE_ASSET__CjHvyxkw__"